export default class CreateProductPricing {
    pricingProfileId: number;
    pricingTermCode:string;
    productId:number;
    price:number=100;
}